"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _vueImageCropUpload = _interopRequireDefault(require("vue-image-crop-upload"));

var _vuex = require("vuex");

var _updatePass = _interopRequireDefault(require("./center/updatePass"));

var _updateEmail = _interopRequireDefault(require("./center/updateEmail"));

var _auth = require("@/utils/auth");

var _store = _interopRequireDefault(require("@/store"));

var _validate = require("@/utils/validate");

var _crud = _interopRequireDefault(require("@/mixins/crud"));

var _user = require("@/api/system/user");

var _avatar = _interopRequireDefault(require("@/assets/images/avatar.png"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'Center',
  components: {
    updatePass: _updatePass.default,
    updateEmail: _updateEmail.default,
    myUpload: _vueImageCropUpload.default
  },
  mixins: [_crud.default],
  data: function data() {
    // 自定义验证
    var validPhone = function validPhone(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!(0, _validate.isvalidPhone)(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };

    return {
      show: false,
      Avatar: _avatar.default,
      activeName: 'first',
      saveLoading: false,
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      form: {},
      rules: {
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          validator: validPhone
        }]
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user', 'updateAvatarApi', 'baseApi'])),
  created: function created() {
    this.form = {
      id: this.user.id,
      nickName: this.user.nickName,
      gender: this.user.gender,
      phone: this.user.phone
    };

    _store.default.dispatch('GetInfo').then(function () {});
  },
  methods: {
    toggleShow: function toggleShow() {
      this.show = !this.show;
    },
    handleClick: function handleClick(tab, event) {
      if (tab.name === 'second') {
        this.init();
      }
    },
    beforeInit: function beforeInit() {
      this.url = 'api/logs/user';
      return true;
    },
    cropUploadSuccess: function cropUploadSuccess(jsonData, field) {
      _store.default.dispatch('GetInfo').then(function () {});
    },
    doSubmit: function doSubmit() {
      var _this = this;

      if (this.$refs['form']) {
        this.$refs['form'].validate(function (valid) {
          if (valid) {
            _this.saveLoading = true;
            (0, _user.editUser)(_this.form).then(function () {
              _this.editSuccessNotify();

              _store.default.dispatch('GetInfo').then(function () {});

              _this.saveLoading = false;
            }).catch(function () {
              _this.saveLoading = false;
            });
          }
        });
      }
    }
  }
};
exports.default = _default;